import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import PageLayout from 'components/common/PageLayout';
import Typography from 'components/common/Typography';
import { format } from 'date-fns';
import {
  Container,
  Content,
  Action,
  Title,
  SubTitle,
} from './SignInActivityScreen.style';
import { useRisClient } from 'hooks/useRisClient';
import { useSuspenseQuery } from '@tanstack/react-query';

const { Description } = PageLayout;
const { Text } = Typography;
const DATE_FORMAT = 'MMMM d, yyyy, h:m a';

const SignInActivityScreen: FC = () => {
  const { t } = useTranslation();
  const { client } = useRisClient();
  const { data } = useSuspenseQuery({
    queryKey: ['GetUserActivity'],
    queryFn: async () =>
      (await client.myUsers.myUsersGetMyUserActivityLogs()).data,
  });

  return (
    <PageLayout title={t('signInSecurity.signInActivity.title')}>
      <Description>
        <Text>{t('signInSecurity.signInActivity.description')}</Text>
      </Description>
      {data?.map((d, index) => (
        <Container key={d.id}>
          <Content>
            <Title>{d?.location}</Title>
            <SubTitle>{`${d?.userAgent} - ${format(new Date(d?.date || ''), DATE_FORMAT)}`}</SubTitle>
          </Content>
          <Action>
            {index === 0 && t('signInSecurity.signInActivity.currentDevice')}
          </Action>
        </Container>
      ))}
    </PageLayout>
  );
};

export default SignInActivityScreen;
